import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASELINE } from "../../util";

const Check_topics = ({ skilldesc, roww, onSelectQuestion, questionIds, setdashboard }) => {
    const [rowsData, setRowsData] = useState([]);
    const [selectedDifficulty, setSelectedDifficulty] = useState("All");
    const [searchQuery, setSearchQuery] = useState("");

    // API call whenever skilldesc changes.
    useEffect(() => {
        if (skilldesc) {
            axios
                .post(BASELINE + "select/gen/topicai", { skill_descs: skilldesc })
                .then((response) => {
                    if (response.data.success) {
                        setRowsData(response.data.data);
                    }
                })
                .catch((error) =>
                    console.error("Error fetching data for", skilldesc, error)
                );
        }
    }, [skilldesc]);

    // Filter rows based on selected difficulty and search query.
    const filteredRows = rowsData.filter((row) => {
        const matchesDifficulty =
            selectedDifficulty === "All" || row.difficultys === selectedDifficulty;
        const matchesSearch = row.questionIds
            .toLowerCase()
            .includes(searchQuery.toLowerCase());
        return matchesDifficulty && matchesSearch;
    });

    // Calculate frequency map for questionIds if needed (existing code)
    const frequencyMap = filteredRows.reduce((acc, row) => {
        acc[row.questionIds] = (acc[row.questionIds] || 0) + 1;
        return acc;
    }, {});

    return (
        <div className="p-4">
            {roww !== 1 && (
                <div className="flex gap-4 items-center">
                    <h2 className="text-2xl font-bold mb-4">Data for {skilldesc}</h2>
                    <button 
                        className="bg-slate-300 p-2 ml-4" 
                        onClick={() => setdashboard(0)}
                    >
                        Back to the Main
                    </button>
                </div>
            )}
            {/* Difficulty selection and search bar */}
            {roww !== 1 ? (
                <div className="flex items-center gap-2 mb-4">
                    <label className="font-semibold">Difficulty:</label>
                    <select
                        value={selectedDifficulty}
                        onChange={(e) => setSelectedDifficulty(e.target.value)}
                        className="p-2 border rounded"
                    >
                        <option value="All">All</option>
                        <option value="E">E</option>
                        <option value="M">M</option>
                        <option value="H">H</option>
                    </select>
                    {/* Display the total number of filtered questions */}
                    <span className="font-semibold">Total: {filteredRows.length}</span>
                    <input
                        type="text"
                        placeholder="Search Question IDs"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="p-2 border rounded"
                    />
                </div>
            ) : (
                <div className="mb-4">
                    <div className="flex items-center gap-2 mb-2">
                        <label className="font-semibold">Difficulty:</label>
                        <select
                            value={selectedDifficulty}
                            onChange={(e) => setSelectedDifficulty(e.target.value)}
                            className="p-2 border rounded"
                        >
                            <option value="All">All</option>
                            <option value="E">E</option>
                            <option value="M">M</option>
                            <option value="H">H</option>
                        </select>
                        {/* Display the total number of filtered questions */}
                        <span className="font-semibold">Total: {filteredRows.length}</span>
                    </div>
                    <input
                        type="text"
                        placeholder="Search Question IDs"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="p-2 border rounded w-full"
                    />
                </div>
            )}

            {/* Cards: if roww === 1, use grid-cols-1; otherwise, grid-cols-4 */}
            <div
                className={`grid ${roww === 1 ? "grid-cols-1 max-h-[700px] overflow-y-scroll" : "grid-cols-4"} gap-4`}
            >
                {filteredRows.map((row, index) => (
                    <div
                        key={index}
                        onClick={() => {
                            // Generate the list of questionIds and call onSelectQuestion.
                            const list = filteredRows.map((r) => r.questionIds);
                            onSelectQuestion(row.questionIds, index, list);
                        }}
                        className={`p-4 border rounded shadow cursor-pointer ${
                            row.questionIds === questionIds ? "border-[8px] border-blue-500" : ""
                        }`}
                        style={{
                            backgroundColor: Number(row.completed) === 1 ? "lightgreen" : "white",
                        }}
                    >
                        {roww === 1 ? (
                            <p>
                                <strong>Question IDs:</strong> {row.questionIds}
                            </p>
                        ) : (
                            <>
                                <p>
                                    <strong>Question IDs:</strong> {row.questionIds}
                                </p>
                                <p>
                                    <strong>Completed:</strong> {row.completed}
                                </p>
                                <p>
                                    <strong>Skill Desc:</strong> {row.skill_descs}
                                </p>
                                <p>
                                    <strong>Difficulty:</strong> {row.difficultys}
                                </p>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Check_topics;
